import { ChangeDetectorRef, Component } from '@angular/core';
import { PluginComponent } from '../../plugin.component';
import { Inspection } from '../../../shared/models/inspection.model';

@Component({
    templateUrl: './lubricant.component.html',
    standalone: false
})
export class InstallationLubricantPluginComponent {
  public lubricants: any[];
  public config: any;
  public editRoute = ['installation', 'lubricant', 'edit'];

  constructor(private cdRef: ChangeDetectorRef) {}

  setConfig(config: any, inspection: Inspection, plugin: any) {
    this.config = config;
    this.initData();
    this.cdRef.detectChanges();
  }

  private initData() {
    this.lubricants = this.config.Lubricants;
  }
}
PluginComponent.plugins['installationlubricant'] = InstallationLubricantPluginComponent;
